// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import { dispatch } from 'store';
import { devConsolelog } from 'helpers/utilityFunctions';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    data: {
        searchType: 'bookings',
        isCommonSearch: false,
        commonSearchKey: {}
    }
};

const slice = createSlice({
    name: 'commonSearch',
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload;
        },

        setSearchData(state, action) {
            devConsolelog('data in setter', action.payload);
            const { searchType, isCommonSearch, commonSearchKey } = action.payload || initialState.data;
            state.data.searchType = searchType;
            state.data.isCommonSearch = isCommonSearch;
            state.data.commonSearchKey = commonSearchKey;
        }
    }
});

export default slice.reducer;

// ----------------------------------------------------------------------

export const getCommonSearchData =
    (searchType, isCommonSearch = false, commonSearchKey = {}) =>
    () => {
        devConsolelog('data in getter', searchType, isCommonSearch, commonSearchKey);
        dispatch(slice.actions.setSearchData({ searchType, isCommonSearch, commonSearchKey }));
    };
